import { get } from '../api';

const getCandidateNotes = (candidateId) =>
  get(`/notes/?owner_id=${candidateId}&sort_by=created_at_desc`);

export default getCandidateNotes;
